import { MutationTree } from "vuex";
import {
  IAssessmentState,
  IAssessmentReviewQuestion,
} from "@/store/modules/assessment/types";

import { IUSection } from "@/store/types";

type AssessmentMutationsTree = MutationTree<IAssessmentState>;

export const mutations: AssessmentMutationsTree = {
  setSection(state: IAssessmentState, section: IUSection) {
    state.section = section;
  },
  setSections(state: IAssessmentState, sections: IUSection[]) {
    state.sections = sections;
  },
  setAnsweredQuestions(
    state: IAssessmentState,
    questions: IAssessmentReviewQuestion[]
  ) {
    state.answeredQuestions = questions;
  },
};
